import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { a as addScrollBarListener } from './scrollbar-CN2h-3bU.js';

class FeaturedCollectionSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;

  connectedCallback() {
    this.#embla = EmblaCarousel(this.querySelector('.embla__viewport'), {
      align: 'center',
      dragFree: true,
      slidesToScroll: 'auto',
      direction: document.dir,
      breakpoints: {
        '(min-width: 64rem)': { active: false },
      },
    });

    addScrollBarListener(this.#embla, this.querySelector('.embla__scrollbar'));
  }
}

customElements.define('featured-collection-slider', FeaturedCollectionSlider);
